import { DatePicker, Form, FormInstance, Radio, Select } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_TW';
import FormItem from 'antd/es/form/FormItem';
import { useWatch } from 'antd/es/form/Form';
import { useEffect } from 'react';

type Props = {
  form: FormInstance;
  providerName: string;
};

const BATCH_COUNT: Record<'lunch' | 'dinner', number> = {
  lunch: 4,
  dinner: 3,
};

export function ProviderStickerPrintForm(props: Props) {
  const orderType =
    useWatch<'lunch' | 'dinner'>('orderType', props.form) ?? 'lunch';

  const batchOptions = Array.from(
    { length: BATCH_COUNT[orderType] },
    (_, i) => ({ label: `第 ${i + 1} 批`, value: i + 1 })
  );

  // 切換餐別時，若目前批次超過該餐別的批次數，回退到最後一批
  useEffect(() => {
    const current = props.form.getFieldValue('batchCode');
    if (current > BATCH_COUNT[orderType]) {
      props.form.setFieldValue('batchCode', BATCH_COUNT[orderType]);
    }
  }, [orderType, props.form]);

  return (
    <Form
      form={props.form}
      layout="vertical"
      initialValues={{
        orderType: 'lunch',
        batchCode: 4,
        version: 'v2',
      }}
    >
      <FormItem>
        <span className="text-gray-500">供應商：{props.providerName}</span>
      </FormItem>
      <FormItem
        label="取餐日期"
        name="redeemDate"
        rules={[{ required: true, message: '請選擇取餐日期' }]}
      >
        <DatePicker locale={locale} className="w-full" />
      </FormItem>
      <FormItem
        label="餐別"
        name="orderType"
        rules={[{ required: true, message: '請選擇餐別' }]}
      >
        <Radio.Group
          options={[
            { label: '午餐', value: 'lunch' },
            { label: '晚餐', value: 'dinner' },
          ]}
        />
      </FormItem>
      <FormItem
        label="批次"
        name="batchCode"
        rules={[{ required: true, message: '請選擇批次' }]}
      >
        <Select options={batchOptions} />
      </FormItem>
      <FormItem
        label="版本"
        name="version"
        rules={[{ required: true, message: '請選擇版本' }]}
      >
        <Radio.Group
          options={[
            { label: '新版（大樓｜取餐號）', value: 'v2' },
            { label: '方形 50×50（含訂購人）', value: 'v3' },
            { label: '舊版', value: 'v1' },
          ]}
        />
      </FormItem>
    </Form>
  );
}
